import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Banner from "../components/layout/Banner";
import { Helmet } from "react-helmet";

const testimonials = [
  {
    name: "ROHAN MEHTA",
    text: "Dr. Vibha team made the entire process smooth and reassuring. The staff was attentive, and the diagnostic lab reports were quick and accurate. I felt well-informed at every step, which really eased my stress."
  },
  {
    name: "PRIYA SHARMA",
    text: "The level of care and professionalism at the clinic is exceptional. From the first consultation to the follow-ups, everything was handled with patience and precision. I finally feel hopeful about starting my family."
  },
  {
    name: "AMIT KHANNA",
    text: "The IVF treatment was explained in detail, and all my doubts were addressed. The staff ensured comfort and confidence throughout the process. Thanks to them, we are now expecting our first child!"
  },
  {
    name: "SNEHA REDDY",
  
    text: "I was nervous about undergoing fertility treatment, but Dr. Meenu Singh and her team made me feel at ease. The care, attention, and encouragement I received were outstanding."
  },
  {
    name: "MEGHA RAO",
    text: "From diagnostics to treatment, the clinic offered professional and compassionate care. The results were timely, and the guidance helped me make informed decisions."
  },
  {
    name: "NEHA GUPTA",
    text: "The staff was empathetic and extremely supportive throughout my fertility journey. Every visit felt personal, and the team explained each step clearly. Our dream is finally coming true."
  }
];

const TestimonialSection = () => {

  // 🎨 Luxury Theme (NOW USED)
  const colors = {
    sectionBg: "#fcfaf8",
    cardBg: "#ffffff",
    accent: "#b76e79",
    accentSoft: "#f8e8ec",
    dark: "#1a1a1a",
    text: "#5a5a5a",
    border: "#eaded6",
  };

  return (
    <>
      <Helmet>
        <title>Testimonials - Dr Meenu’s Clinic | IVF Success Stories</title>
        <meta
          name="description"
          content="Read real patient testimonials and success stories from Dr Meenu’s Clinic."
        />
      </Helmet>

      <Header />

      <Banner
        title="Testimonial"
        subtitle="Excellence in Obstetrics, Gynecology & Maternity Care"
        image="https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/A_patient_exam_room_at_an_urgent_care_clinic_and_doctor%E2%80%99s_office_in_North_Carolina%2C_United_States_06.jpg/1280px-A_patient_exam_room_at_an_urgent_care_clinic_and_doctor%E2%80%99s_office_in_North_Carolina%2C_United_States_06.jpg"
      />

      <section
        className="py-28 px-6"
        style={{ background: `linear-gradient(to bottom, ${colors.sectionBg}, #ffffff, ${colors.sectionBg})` }}
      >
        <div className="max-w-7xl mx-auto">

          {/* ===== Heading ===== */}
          <div className="text-center mb-20">
            <h2
              className="text-4xl md:text-5xl font-bold"
              style={{ color: colors.dark }}
            >
              Patient <span style={{ color: colors.accent }}>Testimonials</span>
            </h2>

            <div
              className="w-24 h-1 mx-auto mt-6 rounded-full"
              style={{ backgroundColor: colors.accent }}
            ></div>

            <p
              className="mt-6 max-w-2xl mx-auto text-lg"
              style={{ color: colors.text }}
            >
              Real stories from families who trusted us with their journey to parenthood.
            </p>
          </div>

          {/* ===== Testimonials Grid ===== */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
            {testimonials.map((item, index) => (
              <div
                key={index}
                className="relative p-8 rounded-3xl shadow-lg hover:shadow-2xl hover:-translate-y-3 transition duration-500"
                style={{
                  backgroundColor: colors.cardBg,
                  border: `1px solid ${colors.border}`,
                }}
              >

                {/* Quote */}
                <div
                  className="absolute -top-6 left-8 text-6xl font-serif"
                  style={{ color: colors.accentSoft }}
                >
                  “
                </div>

                {/* Stars */}
                <div
                  className="mb-4 text-lg tracking-wider"
                  style={{ color: colors.accent }}
                >
                  ★★★★★
                </div>

                {/* Text */}
                <p
                  className="leading-relaxed mb-8 text-base relative z-10"
                  style={{ color: colors.text }}
                >
                  {item.text}
                </p>

                {/* Patient Info */}
                <div className="flex items-center gap-4">
                  <div
                    className="w-12 h-12 rounded-full flex items-center justify-center text-white font-bold"
                    style={{ backgroundColor: colors.accent }}
                  >
                    {item.name.charAt(0)}
                  </div>
                  <div>
                    <h4
                      className="text-sm font-semibold"
                      style={{ color: colors.dark }}
                    >
                      {item.name}
                    </h4>
                   
                  </div>
                </div>

              </div>
            ))}
          </div>

        </div>
      </section>

      <Footer />
    </>
  );
};

export default TestimonialSection;